export default {
  methods: {
    createFormData(form = this.form) {
      const formData = new FormData();

      Object.keys(form).forEach(key => {
        if (Array.isArray(form[key])) {
          form[key].forEach((el, i) => formData.append(`${key}[${i}]`, el));
        } else {
          formData.append(key, form[key]);
        }
      });

      return formData;
    },
    clearForm(
      form = this.form,
      validator = this.$validator,
      defaultValues = {}
    ) {
      Object.keys(form).forEach(key => {
        if (Array.isArray(form[key])) form[key] = [];
        else form[key] = null;
      });
      form = { ...form, ...defaultValues };
      validator.reset();
    }
  }
};
